import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
const TermsServices = () => {
   const { t } = useTranslation();
   return (
      <div className="kap-policy d-flex flex-column" style={{ gap: "16px" }}>
         <p className="kap-policy__title">
            {t("terms-of-service-tab-label")}
         </p>
         <div className="d-flex flex-column" style={{ gap: "16px" }}>
            <div className="d-flex flex-column">
               <p className="mb-6">{t("terms-last-updated-text")}</p>
               <p>
                  {t("terms-intro-websites-prefix-text")}{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.i-aps.com"}
                     className="kap-policy__link"
                  >
                     https://www.i-aps.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kaptechgroup.com"}
                     className="kap-policy__link"
                  >
                     https://kaptechgroup.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kapsurvey.com"}
                     className="kap-policy__link"
                  >
                     https://www.kapsurvey.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kaporg.com"}
                     className="kap-policy__link"
                  >
                     https://www.kaporg.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapinsights.com"}
                     className="kap-policy__link"
                  >
                     https://kapinsights.com
                  </a>{" "}
                  and{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapcourse.com"}
                     className="kap-policy__link"
                  >
                     https://kapcourse.com
                  </a>
                  {t("terms-intro-websites-suffix-text")}
               </p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("overview-of-services-title")}
               </h4>
               <p>{t("overview-of-services-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("limitations-of-use-title")}
               </h4>
               <p>{t("limitations-of-use-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("limitation-modify-content-text")}</li>
                  <li>{t("limitation-remove-notices-text")}</li>
                  <li>{t("limitation-transfer-materials-text")}</li>
                  <li>{t("limitation-abuse-networks-text")}</li>
                  <li>{t("limitation-unlawful-material-text")}</li>
                  <li>{t("limitation-violate-laws-text")}</li>
                  <li>{t("limitation-spam-text")}</li>
                  <li>{t("limitation-harvest-data-text")}</li>
                  <li>{t("limitation-infringe-rights-text")}</li>
               </ul>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("intellectual-property-title")}
               </h4>
               <p>{t("intellectual-property-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("user-generated-content-title")}
               </h4>
               <p>{t("terms-user-generated-content-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("registration-and-payments-title")}
               </h4>
               <p>{t("registration-and-payments-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("disclaimer-and-limitations-title")}
               </h4>
               <p>
                  {t("disclaimer-websites-prefix-text")}{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.i-aps.com"}
                     className="kap-policy__link"
                  >
                     https://www.i-aps.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kaptechgroup.com"}
                     className="kap-policy__link"
                  >
                     https://kaptechgroup.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kapsurvey.com"}
                     className="kap-policy__link"
                  >
                     https://www.kapsurvey.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kaporg.com"}
                     className="kap-policy__link"
                  >
                     https://www.kaporg.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapinsights.com"}
                     className="kap-policy__link"
                  >
                     https://kapinsights.com
                  </a>{" "}
                  and
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapcourse.com"}
                     className="kap-policy__link"
                  >
                     https://kapcourse.com
                  </a>
                  {t("disclaimer-as-is-description-text")}
               </p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("accuracy-of-materials-title")}
               </h4>
               <p>{t("accuracy-of-materials-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("additional-tools-title")}
               </h4>
               <p>{t("additional-tools-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("links-title")}</h4>
               <p>{t("links-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("inaccuracies-and-mistakes-title")}
               </h4>
               <p>{t("inaccuracies-and-mistakes-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("indemnification-title")}
               </h4>
               <p>{t("indemnification-description-text")}</p>
               <p>{t("indemnification-defense-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("right-to-terminate-title")}
               </h4>
               <p>{t("right-to-terminate-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("severance-title")}</h4>
               <p>{t("severance-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("entire-agreement-title")}
               </h4>
               <p>{t("entire-agreement-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("governing-law-title")}</h4>
               <p>{t("governing-law-description-text")}</p>
            </div>
         </div>
      </div>
   );
};

export default TermsServices;
